<template>
  <div :class="modalVisible ? 'modalWrapper visible' : 'modalWrapper'">
    <a href="#" class="bt_modalClose" @click.prevent="closeModal"/>
    <div class="modal">
      <a href="#" class="bt_modalClose" @click.prevent="closeModal"><i class="fa fa-times"/></a>
      <div class="modalHeader">
        <h3>{{ language.t('help') }}</h3>
      </div>
      <div class="modalContent">
        {{ text }}
        <slot/>
      </div>
      <div class="modalFooter">
        <slot name="confirmButton"/>
        <a href="#" class="bt btG" @click.prevent="closeModal">{{$t('modal.close')}}</a>
        <!--        <a href="#" @click.prevent="this.storage.modal.callback" class="bt">Confirmar</a>-->
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useHelperState} from "~/storage/helperModal";
import { watch, ref,onMounted } from 'vue';
import { storeToRefs } from 'pinia';

const helperStore = useHelperState();
const {text, showHelp} = storeToRefs(helperStore);
const modalVisible = ref(false);
const language = useI18n();

onMounted(()=>{
  watch(showHelp, (newValue) => {
    if (newValue) {
      modalVisible.value = true;
    }
  });
})

const closeModal = () => {
  helperStore.hide();
  modalVisible.value = false;
}
</script>
